import { EMPTY_TRANSFER } from './constants'
import type { TransferFormData } from './types'

export const TRANSFER_STEPS = {
  CONTACT: 'contact',
  AMOUNT: 'amount',
  REVIEW: 'review',
  SMS: 'sms',
} as const

export type TransferStep = (typeof TRANSFER_STEPS)[keyof typeof TRANSFER_STEPS]

/** A non-empty ordered list of steps for a given flow variant. */
type StepOrder = readonly [TransferStep, ...TransferStep[]]

export const TRANSFER_FLOW = [
  TRANSFER_STEPS.CONTACT,
  TRANSFER_STEPS.AMOUNT,
  TRANSFER_STEPS.REVIEW,
  TRANSFER_STEPS.SMS,
] as const satisfies StepOrder

export type TransferState = {
  step: TransferStep
  data: TransferFormData
}

export type TransferAction =
  | { type: 'UPDATE'; patch: Partial<TransferFormData> }
  | { type: 'NEXT' }
  | { type: 'BACK' }
  | { type: 'RESET' }

export const initialTransferState = (steps: StepOrder): TransferState => ({
  step: steps[0],
  data: EMPTY_TRANSFER,
})

export const createTransferReducer =
  (steps: StepOrder) =>
  (state: TransferState, action: TransferAction): TransferState => {
    switch (action.type) {
      case 'UPDATE':
        return { ...state, data: { ...state.data, ...action.patch } }
      case 'NEXT': {
        const index = steps.indexOf(state.step)
        const next = steps[Math.min(index + 1, steps.length - 1)] ?? state.step
        return { ...state, step: next }
      }
      case 'BACK': {
        const index = steps.indexOf(state.step)
        const prev = steps[Math.max(index - 1, 0)] ?? state.step
        return { ...state, step: prev }
      }
      case 'RESET':
        return initialTransferState(steps)
      default:
        return state
    }
  }
